// eslint-disable-next-line @fx-ui/jdy-design/import-path-restricted
import { forEach } from '~/utils';
/**
 * @see https://webpack.js.org/guides/dependency-management/#requirecontext
 */
// @ts-ignore
const requireContext = require.context('~/assets/locale_image/', true);
const LOCALE_IMAGE: Record<string, Record<string, string>> = {};
const IMAGE_REG = /\.(jpe?g|png|gif|svg)(\?.+)?$/;
forEach(requireContext.keys(), (path: string) => {
    let localeKey = '';
    let fileKey = '';
    forEach(path.split('/'), (str) => {
        if (!/\./.test(str)) {
            localeKey = str;
        }
        if (IMAGE_REG.test(str)) {
            fileKey = str.replace(IMAGE_REG, '');
        }
    });
    if (!LOCALE_IMAGE[localeKey]) {
        LOCALE_IMAGE[localeKey] = {};
    }
    LOCALE_IMAGE[localeKey]![fileKey] = requireContext(path);
});
export default LOCALE_IMAGE;
